import { render, staticRenderFns } from "./XiaCiDaiMaView.vue?vue&type=template&id=584c1af9&scoped=true"
import script from "./XiaCiDaiMaView.vue?vue&type=script&lang=js"
export * from "./XiaCiDaiMaView.vue?vue&type=script&lang=js"
import style0 from "./XiaCiDaiMaView.vue?vue&type=style&index=0&id=584c1af9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c1af9",
  null
  
)

export default component.exports